import React, { useState, useEffect } from 'react';
import { showError, showSuccess } from '../utils/alertas';

// Configuração de API
const IS_PROD = true; 
const API_BASE_URL = IS_PROD ? 'https://sigoapi.jhe-etes.com.br/api' : 'http://localhost:3001/api';
// 👇 A LINHA QUE FALTAVA ERA ESSA AQUI:
const SERVER_URL = IS_PROD ? 'https://sigoapi.jhe-etes.com.br' : 'http://localhost:3001';

function EdicaoModal({ isOpen, onClose, empreendimento, onUpdateSuccess }) {
  const [formData, setFormData] = useState({});
  const [loading, setLoading] = useState(false);
  const [uploadingCapa, setUploadingCapa] = useState(false);

  useEffect(() => {
    if (empreendimento) {
      setFormData({
        ...empreendimento,
        status_id: empreendimento.status_id || '', 
        status_atual: empreendimento.status_atual || '' 
      });
    }
  }, [empreendimento]);

  if (!isOpen) return null;

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // --- LÓGICA DE UPLOAD DA CAPA ---
  const handleCapaUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setUploadingCapa(true);
    
    // 🔐 1. PEGA O TOKEN
    const token = localStorage.getItem('token');

    const formDataUpload = new FormData();
    formDataUpload.append('file', file);

    try {
      const res = await fetch(`${API_BASE_URL}/upload`, { 
          method: 'POST', 
          // 🔐 2. ENVIA O TOKEN (Sem Content-Type pois é FormData)
          headers: {
            'Authorization': `Bearer ${token}`
          },
          body: formDataUpload 
      });

      if (res.ok) {
        const data = await res.json();
        setFormData(prev => ({ ...prev, imagem_capa_url: data.url })); // Salva a URL no formulário
        showSuccess("Upload Concluído", "Imagem de capa carregada.");
      } else {
        showError("Erro", "Falha ao enviar imagem.");
      }
    } catch (error) {
      showError("Erro", "Erro de conexão no upload.");
    } finally {
      setUploadingCapa(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    // 🔐 1. PEGA O TOKEN
    const token = localStorage.getItem('token');

    try {
      const response = await fetch(`${API_BASE_URL}/empreendimentos/${empreendimento.id}`, {
        method: 'PUT',
        // 🔐 2. ENVIA O TOKEN JUNTO COM O JSON
        headers: { 
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}` 
        },
        body: JSON.stringify(formData)
      });

      if (response.ok) {
        await showSuccess("Sucesso!", "Dados atualizados.");
        onUpdateSuccess(); 
      } else {
        showError("Erro", "Falha ao atualizar dados.");
      }
    } catch (error) {
      console.error(error);
      showError("Erro", "Erro ao conectar com servidor.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm p-4">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-4xl max-h-[90vh] overflow-y-auto flex flex-col">
        
        {/* Header */}
        <div className="p-6 border-b border-gray-100 flex justify-between items-center bg-gray-50 rounded-t-2xl">
          <h2 className="text-xl font-black text-gray-800 flex items-center gap-2">
            <span>⚙️</span> Gerenciar Dados da Obra
          </h2>
          <button onClick={onClose} className="text-gray-400 hover:text-red-500 font-bold text-xl transition-colors">✕</button>
        </div>

        <form onSubmit={handleSubmit} className="p-8 space-y-8">
          
          {/* SEÇÃO 1: CAPA E IDENTIFICAÇÃO */}
          <section>
            <h3 className="text-xs font-bold text-sabesp-blue uppercase tracking-widest mb-4 border-b border-gray-100 pb-2">Identidade Visual</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                
                {/* UPLOAD DA CAPA */}
                <div className="bg-slate-50 p-4 rounded-xl border border-dashed border-gray-300 hover:border-sabesp-blue transition-colors">
                    <label className="block text-xs font-bold text-gray-500 uppercase mb-2">Imagem de Capa (Topo da Página)</label>
                    <div className="flex items-center gap-4">
                        {formData.imagem_capa_url && (
                            <img src={formData.imagem_capa_url.startsWith('http') ? formData.imagem_capa_url : `${IS_PROD ? SERVER_URL : 'http://localhost:3001'}${formData.imagem_capa_url}`} alt="Capa" className="w-16 h-16 object-cover rounded-lg border border-gray-200" />
                        )}
                        <input 
                            type="file" 
                            accept="image/*"
                            onChange={handleCapaUpload}
                            className="block w-full text-sm text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded-full file:border-0 file:text-xs file:font-bold file:bg-sabesp-blue file:text-white hover:file:bg-blue-700"
                        />
                    </div>
                    {uploadingCapa && <p className="text-xs text-blue-500 mt-2 font-bold animate-pulse">Enviando imagem...</p>}
                </div>

                <div>
                    <label className="label-form">Nome do Empreendimento</label>
                    <input name="nome" value={formData.nome || ''} onChange={handleChange} className="input-form" />
                </div>
            </div>
          </section>

          {/* SEÇÃO 2: DADOS GERAIS */}
          <section>
            <h3 className="text-xs font-bold text-gray-400 uppercase tracking-widest mb-4 border-b border-gray-100 pb-2">Dados Gerais</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
               <div><label className="label-form">Descrição Curta (Resumo)</label><textarea name="descricao_curta" value={formData.descricao_curta || ''} onChange={handleChange} className="input-form h-24" /></div>
               <div><label className="label-form">História Completa (Se vazio, some)</label><textarea name="historia_narrativa" value={formData.historia_narrativa || ''} onChange={handleChange} className="input-form h-24" placeholder="Deixe vazio para esconder o card" /></div>
            </div>
          </section>

          {/* SEÇÃO 3: NÚMEROS E TÉCNICA */}
          <section>
            <h3 className="text-xs font-bold text-gray-400 uppercase tracking-widest mb-4 border-b border-gray-100 pb-2">Dados Técnicos</h3>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                <div><label className="label-form">Vazão Atual</label><input name="vazao_atual_ls" value={formData.vazao_atual_ls || ''} onChange={handleChange} className="input-form" /></div>
                <div><label className="label-form">Vazão Futura</label><input name="vazao_futura_ls" value={formData.vazao_futura_ls || ''} onChange={handleChange} className="input-form" /></div>
                <div><label className="label-form">População</label><input name="populacao_atendida" value={formData.populacao_atendida || ''} onChange={handleChange} className="input-form" /></div>
                <div><label className="label-form">Corpo Hídrico</label><input name="corpo_hidrico" value={formData.corpo_hidrico || ''} onChange={handleChange} className="input-form" /></div>
            </div>
          </section>

          <section>
             <h3 className="text-xs font-bold text-gray-400 uppercase tracking-widest mb-4 border-b border-gray-100 pb-2">Textos Especiais</h3>
             <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div><label className="label-form">Diferenciais (Use enter para tópicos)</label><textarea name="texto_diferenciais" value={formData.texto_diferenciais || ''} onChange={handleChange} className="input-form h-20" /></div>
                <div><label className="label-form">Benefícios (Use enter para tópicos)</label><textarea name="texto_beneficios" value={formData.texto_beneficios || ''} onChange={handleChange} className="input-form h-20" /></div>
             </div>
          </section>

          <div className="flex justify-end pt-6 border-t border-gray-100">
            <button type="button" onClick={onClose} className="px-6 py-3 text-gray-500 font-bold hover:bg-gray-100 rounded-xl mr-2 transition-colors">Cancelar</button>
            <button type="submit" disabled={loading || uploadingCapa} className="px-8 py-3 bg-sabesp-blue text-white font-bold rounded-xl hover:bg-blue-900 transition-all shadow-lg hover:shadow-xl disabled:opacity-70">
                {loading ? 'Salvando...' : 'Salvar Alterações'}
            </button>
          </div>

        </form>
      </div>
      
      <style>{`
        .label-form { display: block; font-size: 0.75rem; font-weight: 700; color: #9ca3af; text-transform: uppercase; margin-bottom: 0.5rem; margin-left: 0.25rem; }
        .input-form { width: 100%; padding: 0.75rem 1rem; background-color: #f9fafb; border: 1px solid #e5e7eb; border-radius: 0.75rem; font-size: 0.875rem; color: #374151; font-weight: 600; outline: none; transition: all; }
        .input-form:focus { border-color: #00AEEF; box-shadow: 0 0 0 3px rgba(0, 174, 239, 0.1); background-color: #fff; }
      `}</style>
    </div>
  );
}

export default EdicaoModal;